export const FN10SXXLoginCallback = () => {
  return null;
};
